import { Check, Phone, Mail, HandHeart, Sprout } from "lucide-react";
import { Reveal } from "./shared";

const NURSE = { name: "Nadia", phone: "0432 690 231", phoneHref: "tel:0432690231", email: "nurse@inneryou-development.com.au" };
const NAV_ROLES = ["Liaise with GPs, families and other stakeholders", "Facilitate referrals and identify appropriate services", "Coordinate multidisciplinary care", "Provide advice on funding pathways and service options", "Support complex or high-risk needs"];
const MBS = [
  { title: "Mental Health Care Plan (MHCP)", text: "Referrals from a GP for eligible patients." },
  { title: "Chronic Disease Management Plan (CDMP)", text: "Referrals for eligible patients with chronic and complex conditions." },
];

const NurseNavigator = () => (
  <Reveal className="rounded-[28px] bg-[#FBF9F4] border border-[#3F4A3C]/10 p-7 sm:p-10" >
    <div data-testid="nurse-navigator-card">
      <HandHeart className="w-9 h-9 text-[#3F4A3C]" strokeWidth={1.3} />
      <h3 className="mt-5 font-newsreader text-3xl text-[#3F4A3C]">Our Nurse Navigator</h3>
      <p className="mt-3 font-jakarta text-sm leading-relaxed text-[#4A4F45]">Our Nurse Navigator liaises, facilitates and coordinates care, and supports patients with complex needs.</p>
      <ul className="mt-6 space-y-2.5">{NAV_ROLES.map((r) => <li key={r} className="flex gap-3 font-jakarta text-sm text-[#3F4A3C]"><Check className="w-4 h-4 mt-0.5 shrink-0 text-[#5F7C8A]" />{r}</li>)}</ul>
      <div className="mt-8 rounded-[20px] bg-[#F6F2E9] p-5 sm:p-6">
        <p className="font-jakarta text-sm leading-relaxed text-[#4A4F45]">Need help navigating or advice on an appropriate service? Contact <strong className="font-medium text-[#3F4A3C]">{NURSE.name}, Nurse Navigator</strong>, or our administration team.</p>
        <div className="mt-4 flex flex-col gap-2 font-jakarta text-sm text-[#3F4A3C]">
          <a href={NURSE.phoneHref} data-testid="nurse-phone" className="inline-flex items-center gap-2 hover:text-[#5F7C8A]"><Phone className="w-4 h-4" />{NURSE.phone}</a>
          <a href={`mailto:${NURSE.email}`} data-testid="nurse-email" className="inline-flex items-center gap-2 hover:text-[#5F7C8A] break-all"><Mail className="w-4 h-4 shrink-0" />{NURSE.email}</a>
        </div>
      </div>
    </div>
  </Reveal>
);

const MedicareAllied = () => (
  <Reveal delay={0.1} className="rounded-[28px] bg-[#E3E9E4] p-7 sm:p-10">
    <div data-testid="medicare-allied-card">
      <Sprout className="w-9 h-9 text-[#3F4A3C]" strokeWidth={1.3} />
      <h3 className="mt-5 font-newsreader text-3xl text-[#3F4A3C]">Medicare subsidised allied health services</h3>
      <p className="mt-3 font-jakarta text-sm leading-relaxed text-[#4A4F45]">Our psychologists, mental health occupational therapists and mental health social workers are accepted under:</p>
      <div className="mt-6 space-y-3">
        {MBS.map((m) => (
          <div key={m.title} className="flex items-center gap-4 rounded-[20px] bg-[#FBF9F4] p-4">
            <span className="w-12 h-12 shrink-0 rounded-full bg-[#E3E9E4] grid place-items-center font-newsreader text-sm text-[#3F4A3C]">MBS</span>
            <div><p className="font-newsreader text-lg text-[#3F4A3C]">{m.title}</p><p className="font-jakarta text-xs text-[#4A4F45]">{m.text}</p></div>
          </div>
        ))}
      </div>
      <p className="mt-6 font-jakarta text-sm leading-relaxed text-[#4A4F45]">This provides greater access to psychological, occupational therapy and mental health social work support for your patients with a Medicare rebate.</p>
    </div>
  </Reveal>
);

export const GpSupport = ({ className = "" }) => (
  <section className={`max-w-[1360px] mx-auto px-5 sm:px-10 grid lg:grid-cols-2 gap-5 ${className}`} data-testid="gp-support">
    <NurseNavigator /><MedicareAllied />
  </section>
);
